export const SUBSCRIBER_FUNNEL_STATUSES = [
  { value: 'lead', label: 'Lead' },
  { value: 'prospect', label: 'Prospect' },
  { value: 'active', label: 'Active conversation' },
  { value: 'client', label: 'Client' },
  { value: 'dormant', label: 'Dormant' },
  { value: 'not_a_fit', label: 'Not a fit' },
] as const;

export type SubscriberFunnelStatus = (typeof SUBSCRIBER_FUNNEL_STATUSES)[number]['value'];

export function subscriberFunnelStatusLabel(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return '';
  const slug = value.trim().toLowerCase();
  const known = SUBSCRIBER_FUNNEL_STATUSES.find((item) => item.value === slug);
  return known?.label ?? value.trim().replace(/[_-]+/g, ' ');
}
